import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "ceco-polyglot";
import { Header } from "../../components/cecoadmin-panel";
import FullWidthLayout from "../../layout/FullWidthLayout";
import CreateButton from "../../components/CreateButton";
import { Dimmer, Loader } from "semantic-ui-react";
import { UnitsTable } from "../../components/tables/UnitsTable";
import graphql from "babel-plugin-relay/macro";
import { createPaginationContainer } from "react-relay";

const UnitsPage = ({
  menuExpanded,
  setMenuExpanded,
  children,
  allUnitMeasure,
  allCategories,
  relay,
  ...rest
}) => {
  const [search, setSearch] = useState();
  const { totalCount, edges } = allUnitMeasure.allUnitMeasure;
  const [isLoading, setIsLoading] = useState(false);
  const loadSearch = useRef(false);

  const unitsParsed = edges.map((unit, i) => {
    return {
      ...unit.node,
    };
  });

  const t = useTranslation();
  useEffect(() => {
    document.title = `Recetario Mambo - ${t("title.units")}`;
  }, [t]);

  const _loadMore = () => {
    if (!relay.hasMore() || relay.isLoading()) {
      return;
    }
    setIsLoading(true);
    relay.loadMore(20, (t) => {
      setIsLoading(false);
    });
  };

  const _refetch = () => {
    setIsLoading(true);

    relay.refetchConnection(
      search === "" || search === undefined ? 20 : null,
      () => setIsLoading(false),
      {
        name: search === "" || search === undefined ? null : search,
      }
    );
  };

  const handleScroll = (e) => {
    const target = e.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      _loadMore();
    }
  };

  const onSearchText = useCallback(
    (txt) => {
      setSearch(txt);
    },
    [setSearch]
  );

  useEffect(() => {
    if (loadSearch.current) {
      setIsLoading(true);

      relay.refetchConnection(
        search === "" || search === undefined ? 20 : null,
        () => setIsLoading(false),
        {
          code: search === "" || search === undefined ? null : search,
        }
      );
    }
    loadSearch.current = true;
  }, [relay, search]);

  return (
    <FullWidthLayout>
      <Header
        title={t("title.units")}
        menuExpanded={menuExpanded}
        setMenuExpanded={setMenuExpanded}
        onSearchTextChange={onSearchText}
      >
        <CreateButton allCategories={allCategories} refetchData={_refetch} />
      </Header>
      <div className="units table-wrapper">
        <>
          <UnitsTable
            unitsParsed={unitsParsed}
            totalCount={totalCount}
            _refetch={_refetch}
            handleScroll={handleScroll}
            {...rest}
          />
          {isLoading && (
            <Dimmer inverted active>
              <Loader indeterminate />
            </Dimmer>
          )}
        </>
      </div>
    </FullWidthLayout>
  );
};

export default createPaginationContainer(
  UnitsPage,
  {
    allUnitMeasure: graphql`
      fragment UnitsPage_allUnitMeasure on Query
      @argumentDefinitions(
        code: { type: "String" }
        count: { type: "Int", defaultValue: 20 }
        cursor: { type: "String" }
      ) {
        allUnitMeasure(code: $code, first: $count, after: $cursor)
          @connection(key: "Units_allUnitMeasure") {
          totalCount
          edges {
            node {
              id
              code
              description
            }
          }
        }
      }
    `,
  },
  {
    direction: "forward",
    getConnectionFromProps(props) {
      return props.allUnitMeasure && props.allUnitMeasure.allUnitMeasure;
    },

    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        count,
        cursor,
      };
    },
    query: graphql`
      query UnitsPagePaginationQuery(
        $count: Int
        $cursor: String
        $code: String
      ) {
        ...UnitsPage_allUnitMeasure
          @arguments(count: $count, cursor: $cursor, code: $code)
      }
    `,
  }
);
